import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, Lock, User as UserIcon } from 'lucide-react';
import { toast } from 'sonner';
import { Logo } from '../components/Logo';
import { API } from '../config';
import { useAuth } from '../contexts/AuthContext';

const inputStyle = { background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', color: '#F8FAF9' };
const cardStyle = { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)' };
const playfairFont = "'Playfair Display', serif";

export const Register = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submitForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(
        `${API}/auth/register`,
        { name, email: email.trim().toLowerCase(), password },
        { withCredentials: true },
      );
      toast.success('Akun berhasil dibuat — selamat datang!');
      await checkAuth();
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Registrasi gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: '#080C0A' }}>
      <div className="absolute inset-0">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(3,32,20,0.4) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(212,175,55,0.1) 0%, transparent 50%)' }} />
      </div>
      <div className="relative z-10 min-h-screen flex items-center justify-center p-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md">
          <div className="text-center mb-10">
            <Logo size={72} animated={false} />
            <h1 className="text-4xl font-light mt-4 mb-2" style={{ fontFamily: playfairFont, color: '#F8FAF9' }}>
              Buat Akun
            </h1>
            <p className="text-xs tracking-[0.2em] uppercase" style={{ color: '#A3B8AC' }}>
              Bergabung dengan LimHappyShop
            </p>
          </div>

          <div className="rounded-2xl p-8 backdrop-blur-2xl" style={cardStyle}>
            <form onSubmit={submitForm} className="space-y-5" data-testid="register-form">
              <div>
                <label className="block text-sm mb-2" style={{ color: '#A3B8AC' }}>Nama Lengkap</label>
                <div className="relative">
                  <UserIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#A3B8AC' }} />
                  <input type="text" value={name} onChange={(e) => setName(e.target.value)} required minLength={2}
                    className="w-full rounded-lg pl-12 pr-4 py-3.5 outline-none" style={inputStyle}
                    placeholder="John Doe" data-testid="name-input" />
                </div>
              </div>
              <div>
                <label className="block text-sm mb-2" style={{ color: '#A3B8AC' }}>Email</label>
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#A3B8AC' }} />
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                    className="w-full rounded-lg pl-12 pr-4 py-3.5 outline-none" style={inputStyle}
                    placeholder="anda@email.com" data-testid="email-input" />
                </div>
              </div>
              <div>
                <label className="block text-sm mb-2" style={{ color: '#A3B8AC' }}>Password</label>
                <div className="relative">
                  <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#A3B8AC' }} />
                  <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
                    className="w-full rounded-lg pl-12 pr-4 py-3.5 outline-none" style={inputStyle}
                    placeholder="Min. 6 karakter" data-testid="password-input" />
                </div>
                <p className="text-xs mt-2" style={{ color: '#6B8079' }}>
                  Tidak perlu verifikasi email. Anda bisa langsung berbelanja & ikut Kuji setelah daftar.
                </p>
              </div>
              <button type="submit" disabled={loading}
                className="w-full rounded-full px-8 py-4 font-medium disabled:opacity-50"
                style={{ background: '#D4AF37', color: '#080C0A' }} data-testid="register-submit-btn">
                {loading ? 'Membuat akun...' : 'Daftar & Masuk'}
              </button>
            </form>
            <div className="mt-8 text-center text-sm" style={{ color: '#A3B8AC' }}>
              Sudah punya akun?{' '}
              <Link to="/login" className="font-medium" style={{ color: '#D4AF37' }} data-testid="login-link">Login</Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
